<script>
    export default {
        props: {
            label: String,
        },
    };
</script>

<template>
    <div class="dashboard-widget is-flex is-justify-content-center is-align-items-center">
        <span>{{ label }}</span>
    </div>
</template>
